import {
  takeLatest,
  put,
  call,
  all,
  spawn,
  take,
  race,
  select,
} from 'redux-saga/effects';
import get from 'lodash/get';

import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../../../constants/formFields';
import { INSURANCE_FLOW_TYPE } from '../../../constants/insurance-flow-type';
import { MANAGE_INSURANCES_ACTION_TYPES } from '../actions/manage-insurances-actions';
import { actions as exportPatientInsuranceEhrDocumentsActions } from '../requests/export-patient-insurance-ehr-documents';

import { editUserAfterInsuranceUpdate } from './edit-user-after-insurance-update';
import {
  actions as checkInsuranceActions,
  consts as checkInsuranceConsts,
} from '../../appointmentForm/requests/check-insurance-eligibility';
import {
  actions as createPatientInsuranceActions,
  consts as createPatientInsuranceConsts,
} from '../requests/create-patient-insurance';
import {
  actions as updatePatientInsuranceActions,
  consts as updatePatientInsuranceConsts,
} from '../requests/update-patient-insurance';

import { selectIsAdditionalInsurancesEnabled } from '../selectors/get-patient-insurances-list';

import { getRequestPayloadFromFormState } from '../../../utils/manage-insurances/get-request-payload-from-form-state';
import { convertInsuranceFormDataToFormData } from '../../../utils/manage-insurances/convert-insurance-form-data-to-form-data';

const { DO_NOT_HAVE_INSURANCE } = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

function* handleAdditionalInsuranceAction(insuranceFormState, userId) {
  const insuranceFormData = yield call(
    getRequestPayloadFromFormState,
    insuranceFormState,
  );

  const insuranceId = get(insuranceFormState, 'id');

  const data = yield call(convertInsuranceFormDataToFormData, {
    insuranceFormData,
    userId,
    insuranceId,
  });

  if (insuranceId) {
    yield put(updatePatientInsuranceActions.send(data));
    yield take(updatePatientInsuranceConsts.SUCCEED);
    yield;
  } else {
    yield put(createPatientInsuranceActions.send(data));
    yield take(createPatientInsuranceConsts.SUCCEED);
  }
}

function* saveInsurancesDataWorker({ payload }) {
  const {
    userId,
    mainInsuranceFormState,
    additionalInsurancesFormState = [],
    finishAction,
    flowType,
  } = payload;

  const mainInsuranceFormData = yield call(
    getRequestPayloadFromFormState,
    mainInsuranceFormState,
  );

  const healthPlan = get(mainInsuranceFormState, 'healthPlan', null);
  const isPlanNotListedSelected = Boolean(healthPlan && !healthPlan.id);

  const isAdditionalInsurancesEnabled = yield select(
    selectIsAdditionalInsurancesEnabled,
  );

  const skipInsurance = Boolean(mainInsuranceFormState[DO_NOT_HAVE_INSURANCE]);

  let checkSucceed = true;

  if (!isPlanNotListedSelected && !skipInsurance) {
    yield put(checkInsuranceActions.send({ ...mainInsuranceFormData, userId }));

    const { succeed } = yield race({
      succeed: take(checkInsuranceConsts.SUCCEED),
      failed: take([
        checkInsuranceConsts.REJECTED,
        checkInsuranceConsts.ERROR_ENCOUNTERED,
      ]),
    });

    checkSucceed = succeed;
  }

  if (
    additionalInsurancesFormState.length &&
    isAdditionalInsurancesEnabled &&
    !skipInsurance
  ) {
    yield all(
      additionalInsurancesFormState.map(insuranceFormState => {
        const additionalInsurancesHealthPlan = get(
          insuranceFormState,
          'healthPlan',
          null,
        );
        const additionalInsurancesIsPlanNotListedSelected = Boolean(
          additionalInsurancesHealthPlan && !additionalInsurancesHealthPlan.id,
        );

        if (additionalInsurancesIsPlanNotListedSelected) {
          return;
        }

        return spawn(
          handleAdditionalInsuranceAction,
          insuranceFormState,
          userId,
        );
      }),
    );
  }

  if (checkSucceed && !isPlanNotListedSelected) {
    yield call(editUserAfterInsuranceUpdate, {
      userId,
      skipInsurance,
      finishAction,
      flowType,
    });
  } else if (finishAction) {
    yield call(finishAction);
  }

  if (flowType === INSURANCE_FLOW_TYPE.PROFILE && !skipInsurance) {
    yield put(exportPatientInsuranceEhrDocumentsActions.send({ userId }));
  }
}

export function* saveInsurancesData() {
  yield takeLatest(
    MANAGE_INSURANCES_ACTION_TYPES.SAVE_PATIENT_INSURANCES,
    saveInsurancesDataWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/save-insurances-data.js